import { defineNuxtPlugin } from '#app/nuxt';
import { reloadNuxtApp } from '#app/composables/chunk';

export default defineNuxtPlugin({
  setup(nuxtApp) {
    nuxtApp.hook('app:chunkError', () => {
      reloadNuxtApp();
    });
  },
});
